import {
    EVENT_NEW_SHIELD_ASSET_TEAM1,
    EVENT_NEW_SHIELD_ASSET_TEAM2,
} from "../actions/action-types";

const INITIAL_STATE = {
};

function eventState(state = INITIAL_STATE, action) {
    switch (action.type) {
        case EVENT_NEW_SHIELD_ASSET_TEAM1: {
            return {...state, eventNewShieldTeam1: action.data}
        }
        case EVENT_NEW_SHIELD_ASSET_TEAM2: {
            return {...state, eventNewShieldTeam2: action.data}
        }
        default:
            return state;
    }
}

export default eventState;